import { Flex, Text, Tooltip } from '@mantine/core';
import React from 'react';
import * as Unicons from '@iconscout/react-unicons';

interface CourseLikeProps {
  likes: number;
}
const CourseLike: React.FC<CourseLikeProps> = ({ likes }) => {
  return (
    <Tooltip label={likes.toLocaleString('id-ID') + ' Likes'}>
      <Flex gap={4} align={'center'}>
        <Unicons.UilThumbsUp size="14" />
        <Text fz={13} fw={700}>
          {likes.toLocaleString('id-ID')}
        </Text>
      </Flex>
    </Tooltip>
  );
};

export default CourseLike;
